<script>
import { SancareOcticon } from '@sancare/typescript-commons'
import _ from 'lodash'
import { mapState } from 'vuex'

import { DiagnosisType } from '@/store/modules/diagnosis/types.ts'

export default {
  components: {
    'sancare-octicon': SancareOcticon,
  },
  props: {
    type: { type: String, required: true },
    contextDate: { type: Object, required: true },
    readOnly: { type: Boolean, default: false },
    canAddUncommonDiagnoses: { type: Boolean, default: true }
  },
  emits: ['add-diagnosis'],
  data() {
    return {
      inputStatus: {
        showInput: false,
        typedDiagnosis: '',
        errorMessage: '',
      },
      displaySearch: false,
      DiagnosisType
    }
  },
  computed: mapState({
    addDiagnosisRequest(state){
      return state.stayDisplayer.addDiagnosisRequest[this.type]
    },
    diagnosisSearchResults(state) {
      return state.stayDisplayer.diagnosisSearchResults[this.type]
    },
  }),
  watch: {
    addDiagnosisRequest: function(req) {
      if (req.ok) {
        this.toggleInput(false)
        this.$store.commit('clearSearchDiagnoses', this.type)
      }
    }
  },
  methods: {
    toggleInput(openedState) {
      this.inputStatus = {
        showInput: openedState !== undefined ? openedState : !this.inputStatus.showInput,
        typedDiagnosis: '',
        errorMessage: '',
      }
      if (!this.inputStatus.showInput) {
        this.$store.commit('resetAddDiagnosis', this.type)
        this.displaySearch = false
        this.$store.commit('clearSearchDiagnoses', this.type)
      }
    },
    manualDiagInputFocus() {
      if (this.addDiagnosisRequest.ok || this.addDiagnosisRequest.error) {
        this.$store.dispatch('resetAddDiagnosis', this.type)
      }
      this.displaySearch = true
    },
    manualDiagInputTyped(event) {
      if (event.key === 'Enter') {
        this.addManualDiag()
        this.$refs.manualDiagInput.blur()
      }
      if (this.addDiagnosisRequest.ok || this.addDiagnosisRequest.error) {
        this.$store.dispatch('resetAddDiagnosis', this.type)
      }
      this.displaySearch = event.key !== 'Escape'

      this.triggerSearch()
    },
    triggerSearch: _.throttle(function() {
      const contextDate = this.contextDate.format('YYYY-MM-DD')
      if (this.inputStatus.typedDiagnosis) {
        this.$store.dispatch('searchDiagnoses', { diagnosisType: this.type, contextDate, search: this.inputStatus.typedDiagnosis })
      } else {
        this.$store.commit('clearSearchDiagnoses', this.type)
      }
    }, 500, { leading: false, maxWait: 500, trailing: true }),
    handleSearchClick(ref) {
      this.inputStatus.typedDiagnosis = ref
      this.addManualDiag()
    },
    addManualDiag() {
      if (!this.canAddUncommonDiagnoses && _.findIndex(this.diagnosisSearchResults, ['reference', this.inputStatus.typedDiagnosis.toUpperCase()]) === -1) {
        this.inputStatus.errorMessage = 'Ce diagnostic est inconnu'
        return
      }

      this.$emit('add-diagnosis', this.inputStatus.typedDiagnosis.toUpperCase())
      this.displaySearch = false
      this.typedDiagnosis = ''
    },
    hideDisplaySearch() {
      this.displaySearch = false
    }
  },
}
</script>

<template>
  <div
    v-on-click-outside="hideDisplaySearch"
    class="col mb-2"
  >
    <div
      v-if="!readOnly"
      :class="{
        disabled: addDiagnosisRequest.fetching,
        active: inputStatus.showInput
      }"
      class="row mb-3 px-2 g-0 btn btn-coding-element btn-diagnosis"
      @click="toggleInput()"
    >
      <div
        v-if="inputStatus.showInput"
        class="col-auto icon-block px-2"
      >
        <sancare-octicon
          name="x"
          :width="15"
          :height="15"
        />
      </div>
      <div
        v-else
        class="col-auto icon-block px-2"
      >
        <sancare-octicon
          :name="type === DiagnosisType.DAS ? 'plus' : 'pencil'"
          :width="15"
          :height="15"
        />
      </div>
      <div class="col">
        {{ $t('diagnosis.'+type) }} manuel
      </div>
    </div>
    <transition name="slidein-fadein">
      <div
        v-if="inputStatus.showInput"
        class="popup-search"
      >
        <div class="row g-0 align-items-center">
          <input
            ref="manualDiagInput"
            v-model="inputStatus.typedDiagnosis"
            class="col form-control popup-search-input"
            @keyup="manualDiagInputTyped"
            @focus="manualDiagInputFocus"
          >
          <transition
            name="manual-diagnosis-loader"
            mode="out-in"
          >
            <div
              v-if="!addDiagnosisRequest.fetching"
              class="arrow col-auto text-end icon-block"
              @click="addManualDiag"
            >
              <sancare-octicon
                name="arrow-right"
                :width="20"
                :height="20"
              />
            </div>
            <div
              v-else
              class="loader loader-xs loader-purple"
            />
          </transition>
        </div>
        <div
          v-if="inputStatus.errorMessage"
          class="text-danger my-2"
        >
          <sancare-octicon
            class="icon-danger"
            name="alert"
            :width="20"
            :height="20"
          />
          {{ inputStatus.errorMessage }}
        </div>
      </div>
    </transition>
    <div class="autocompletion-container">
      <div
        v-if="displaySearch && diagnosisSearchResults.length"
        class="autocompletion"
      >
        <div
          v-for="diag in diagnosisSearchResults"
          :key="diag.reference"
          class="autocompletion__item"
          @click="handleSearchClick(diag.reference)"
        >
          <div class="autocompletion__item-title">
            {{ diag.reference }}
          </div>
          <div class="autocompletion__item-subtitle">
            {{ diag.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
